export const fontSizeList = [12, 14, 16, 18, 20, 24, 28, 30, 32, 36, 40, 48, 64, 72, 96, 120, 144];